import { useState } from "react";
import PropTypes from "prop-types";

import ProviderHistoryPopup from "../../Modals/ProviderHistoryPopup";
import historyIcon from "../../../assets/history.svg";

// Opens the provider history report for a provider listing (treatment panels, search, etc.).
const ProviderHistoryButton = ({
  providerId,
  specialty,
  providerName,
  treatmentFirstConnected,
}) => {
  const [show, setShow] = useState(false);

  if (!providerId) return null;

  return (
    <>
      <button
        type="button"
        title="Provider History"
        aria-label="Provider History"
        className="btn p-0 d-flex align-items-center justify-content-center"
        style={{ width: "25px", height: "25px", border: "none", background: "transparent" }}
        onClick={(e) => {
          e.stopPropagation();
          setShow(true);
        }}
      >
        <img src={historyIcon} alt="" style={{ width: "21px", height: "21px" }} />
      </button>

      {show && (
        <ProviderHistoryPopup
          show={show}
          handleClose={() => setShow(false)}
          providerId={providerId}
          specialty={specialty}
          providerName={providerName}
          treatmentFirstConnected={treatmentFirstConnected}
        />
      )}
    </>
  );
};

ProviderHistoryButton.propTypes = {
  providerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  specialty: PropTypes.object,
  providerName: PropTypes.string,
  treatmentFirstConnected: PropTypes.bool,
};

export default ProviderHistoryButton;
